import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './auth/AuthGate';
import { TenantProvider } from './auth/TenantProvider';
import { UserDirectoryProvider } from './auth/UserDirectory';
import { ListScreen } from './pages/ListScreen';
import { NewAgendaScreen } from './pages/NewAgendaScreen';
import { EditorScreen } from './pages/EditorScreen';
import { PreviewScreen } from './pages/PreviewScreen';
import { TimelineScreen } from './pages/TimelineScreen';

export function App() {
  return (
    <AuthGate>
      <TenantProvider>
        <UserDirectoryProvider>
          <Routes>
            <Route path="/" element={<ListScreen />} />
            <Route path="/new" element={<NewAgendaScreen />} />
            <Route path="/agenda/:id/edit" element={<EditorScreen />} />
            <Route path="/agenda/:id/preview" element={<PreviewScreen />} />
            <Route path="/agenda/:id/timeline" element={<TimelineScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </UserDirectoryProvider>
      </TenantProvider>
    </AuthGate>
  );
}
